<div *ngIf="isOpen$ | async" class="modal-overlay" (click)="close()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <button class="close-button text-qundis-primary" (click)="close()">
        &times;
      </button>
    </div>
    <ng-content></ng-content>
  </div>
</div>
